import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { ListPanel } from '@eika/link-panel';

import { useConfig } from '../../defaultConfig';
import type { Account } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { loansTrackingIDs } from '../../utils/gtm/trackIDs/loans';
import { currencyFormatter } from '../shared/numberFormat';
import { LoanLabels } from './LoanLabels';
import { getLoanArrear } from './loanUtils';

interface Props {
    loan: Account;
    url: string;
}

const LoanListItem: React.FC<Props> = ({ loan, url }) => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    const loanArrears = featureToggles.enableLoanArrears ? getLoanArrear(loan.balance) : undefined;
    const arrearsText = loanArrears !== undefined ? `${translated.loans.arrearsBalance}${loanArrears}` : undefined;

    return (
        <ListPanel
            url={`${url}/?id=${loan.accountId.value}`}
            title={loan.alias}
            textOne={currencyFormatter(loan.balance.accountingBalance, loan.currency)}
            textTwo={formatAccountNumber(loan.accountNumber)}
            textThree={arrearsText}
            labels={<LoanLabels balance={loan.balance} owners={loan.owners} />}
            as="li"
            data-track-id={loansTrackingIDs.loanOverview}
            data-track-linkname={loan.alias}
        />
    );
};

export default LoanListItem;
